// @flow

/**
 * Module dependencies.
 */

import { branch, translator } from 'core/utils';
import { colors, units } from 'client/styles';
import { compose } from 'recompose';
import { get } from 'lodash';
import Content from 'client/components/content';
import Header from 'client/components/header';
import Information from 'client/components/about/information';
import Layout from 'client/components/core/layout';
import PageContent from 'client/components/core/page-content';
import React, { Component } from 'react';
import StaticSections from 'client/components/static-sections';
import StickyNavbarTrigger from 'client/components/core/sticky-navbar/sticky-navbar-trigger';
import Team from 'client/components/about/team';
import TeamExperience from 'client/components/about/team-experience';
import Transferring from 'client/components/transferring';
import config from 'config';
import teamEntities from 'client/core/entities/team';

/**
 * `Props` type.
 */

type Props = {
  i18n: Object,
  translate: Function
};

/**
 * `About` component.
 */

class About extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { i18n, translate } = this.props;
    const { language } = i18n;
    const logos = ['babb', 'uphold', 'airtm', 'corillian', 'm35ltd'];
    const teamMembers = teamEntities(translate);
    const isPtLanguage = language === get(config, 'i18n.defaultLng');
    const whoWeAreItems = [{
      text: translate('about.whoWeAre.currency.text'),
      title: translate('about.whoWeAre.currency.title')
    }, {
      text: translate('about.whoWeAre.security.text'),
      title: translate('about.whoWeAre.security.title')
    }, {
      text: translate('about.whoWeAre.proccess.text'),
      title: translate('about.whoWeAre.proccess.title')
    }, {
      text: translate('about.whoWeAre.agents.text'),
      title: translate('about.whoWeAre.agents.title')
    }, {
      text: translate('about.whoWeAre.availableSwaps.text'),
      title: translate('about.whoWeAre.availableSwaps.title')
    }];

    return (
      <PageContent background={colors.shadesOfSand2.pampasDarker}>
        <Header
          filename={'about-us-header'}
          title={translate('about.title')}
        />

        <Content
          paddingVertical={13}
          pullTop
          separator
        >
          <Information
            lead={translate('about.vision.lead')}
            title={translate('about.vision.title')}
            titleColor={colors.brandPrimary}
          />
        </Content>

        <Content
          background={colors.brandPrimary}
          backgroundImage={'pattern-1'}
          paddingVertical={13}
        >
          <Information
            lead={translate('about.mission.lead')}
            leadColor={colors.white}
            title={translate('about.mission.title')}
            titleColor={colors.white}
          />
        </Content>

        <StickyNavbarTrigger>
          <Content
            background={colors.transparent}
            paddingVertical={13}
          >
            <StaticSections
              items={whoWeAreItems}
              lead={translate('about.whoWeAre.lead')}
              title={translate('about.whoWeAre.title')}
            />
          </Content>

          {branch(isPtLanguage, () => (
            <div>
              <Layout
                background={colors.shadesOfSand2.pampasLighter}
                paddingVertical={units(13)}
              >
                <Team members={teamMembers} />
              </Layout>

              <Layout
                background={colors.brown}
                paddingVertical={units(13)}
              >
                <TeamExperience logos={logos} />
              </Layout>
            </div>
          ))}

          <Transferring underlayColor={isPtLanguage ? colors.brown : null} />
        </StickyNavbarTrigger>
      </PageContent>
    );
  }

}

/**
 * Export `About`.
 */

export default compose(
  translator()
)(About);



// WEBPACK FOOTER //
// ../src/client/containers/about/index.js